import { diff, detailedDiff } from 'deep-object-diff';

interface IDiffOptions {
	debug?: boolean;
}

export const isObjectChanged = (
	initial: object,
	current: object,
	options?: IDiffOptions
) => {
	if (options?.debug) {
		console.log(detailedDiff(initial, current));

		console.log('Initial: ', initial);
		console.log('Current: ', current);
	}

	const diffResult = diff(initial, current);

	return !!Object.keys(diffResult).length;
};
